{
	"imprintTitle": "Impressum",
	"termsAndConditionsTitle": "Villkor",
	"privacyPolicyTitle": "Integritetspolicy",
	"openSourceAttributionTitle": "Open source-attribuering"
}
